module.exports = __webpack_public_path__ + "bbb9c937317f682ba1f2b0c524470aa3.svg";